import { getAttendees } from '../../../selectors/order';
import { getSelectedDeliveryMethodForCountry } from '../../../utils/deliveryMethod';
import { updateOrderAttendeesAction } from '../actions';

export const updateOrderAttendeesDefaultDeliveryMethodByCountry =
    (selectedCountry) => (dispatch, getState) => {
        const state = getState();
        const attendees = getAttendees(state);
        const attendeesWithDefaultDeliveryMethod = attendees.map(
            ({ deliveryMethod, ticketClass = {}, ...rest }) => ({
                ...rest,
                ticketClass,
                deliveryMethod: getSelectedDeliveryMethodForCountry({
                    deliveryMethods: ticketClass.deliveryMethods,
                    selectedDeliveryMethod: deliveryMethod,
                    selectedCountry,
                }),
            }),
        );

        dispatch(
            updateOrderAttendeesAction(attendeesWithDefaultDeliveryMethod),
        );
    };
